import { AppContext } from 'next/app';

import { ApiClient } from '@klokhuis/core/ApiClient';
import { AppCookieName, readAppCookies } from '@klokhuis/core/Cookie';
import { SessionFeatureFlags } from '@klokhuis/core/FeatureFlags/types';

import { IAuthState } from './types';

export async function initAuthServerApp(
  appContext: AppContext,
  _sessionFeatureFlags: SessionFeatureFlags,
) {
  let authState: IAuthState = {
    userProfile: null,
    anonymousId: null,
    refreshToken: null,
    accessToken: null,
  };

  const req = appContext.ctx.req!;
  const res = appContext.ctx.res!;

  const apiClient = new ApiClient();

  const appCookies = readAppCookies(req);

  // Read tokens from cookies
  const accessToken = req.cookies[AppCookieName.ACCESS_TOKEN] || null;
  const refreshToken = req.cookies[AppCookieName.REFRESH_TOKEN] || null;

  // Only set accessToken if it exists - validation will happen on API calls
  // This prevents blocking SSR with API calls
  if (accessToken) {
    authState.accessToken = accessToken;
    authState.refreshToken = refreshToken;
  }

  apiClient.withCookies(appCookies);

  Object.assign(req, {
    authState,
    apiClient,
  });

  return authState;
}
